module.exports = __webpack_public_path__ + "static/media/15.18cf8509.png";